import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scroll-to-top on route change.
 *
 * - On a PUSH (regular navigation: tapping a link, navigate()) → snap to top.
 * - On a POP (browser back/forward button) → restore the previous scroll
 *   position so back-button feels natural.
 * - On a REPLACE (no real navigation) → leave the scroll alone.
 *
 * Also disables the browser's automatic scroll-restoration on hard reload,
 * so refreshing any page always lands you at the top.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // Anchor links (#section) → let the browser handle it natively.
    if (hash) return;
    if (navType === "POP") return;
    // Use 'instant' so it doesn't fight with page transitions on big pages.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash, navType]);

  return null;
}
